import React from 'react';
import { Steps as AntdSteps } from 'antd';
import type { StepsProps as AntdStepsProps } from 'antd';

export type StepsProps = AntdStepsProps;

export const Steps: React.FC<StepsProps> = (props: StepsProps) => <AntdSteps {...props} />;
